import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Pagination } from 'src/domains/common/components/pagination/pagination';
import { Select } from 'src/domains/common/components/select/select';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { ValueType } from 'src/domains/common/components/select/select.state';
import { cn } from 'src/domains/common/components/utils';

export type PaginationConfigType<T> = {
    currentPage: number;
    endItem: number;
    setPage: (page: number) => void;
    startItem: number;
    totalItems: number;
    totalPages: number;
    rowsPerPageState: FormInputState<T, string>;
    selectValues: Array<ValueType<T>>;
    fixedPageSize?: number;
};

interface PaginationTablePropsType<T> {
    config: PaginationConfigType<T>;
    isAutoPosition?: boolean;
    selectClassName?: string;
}

export const PaginationTable = observer(
    'PaginationTable',
    <T,>({
        config: {
            currentPage,
            endItem,
            setPage,
            startItem,
            totalItems,
            totalPages,
            rowsPerPageState,
            selectValues,
            fixedPageSize,
        },
        selectClassName,
        isAutoPosition = true,
    }: PaginationTablePropsType<T>): JSX.Element => {
        const itemsShown = startItem === 0 && endItem === 0 ? 0 : `${startItem}-${endItem}`;

        return (
            <div className='flex items-center justify-between pt-4 font-tertiary'>
                <div className='flex items-center gap-2'>
                    <span className='text-xs whitespace-nowrap'>
                        <b className='font-semibold'>{itemsShown}</b>
                        &nbsp;of&nbsp;
                        <b className='font-semibold'>{totalItems}</b>
                        <span className='mx-2'>|</span>Results per page:
                    </span>

                    {fixedPageSize === undefined ? (
                        <Select
                            dataTest='pagination-dropdown'
                            className={cn('w-28', selectClassName)}
                            formInputState={rowsPerPageState}
                            placeholder='10'
                            triggerClassName='w-[70px]'
                            values={selectValues}
                            isAutoPosition={isAutoPosition}
                            errors={[]}
                        />
                    ) : (
                        <span className='text-xs whitespace-nowrap font-bold'>{fixedPageSize.toString()}</span>
                    )}
                </div>

                <Pagination
                    currentPage={currentPage}
                    onPageChange={setPage}
                    totalPages={totalPages}
                />
            </div>
        );
    }
);
